import { IconButton } from "@material-ui/core"
import Div100vh from "react-div-100vh"
import {
  Holder,
  Content,
  LeftSection,
  TitleHolder,
  TipHolder,
  ContactHolder,
  Footer,
  BackButton,
  Logo,
  RightSection,
  ContactTitle,
  ContactValue,
  ContactList
} from "./FutureElements.js"
import SplitText from "../../../components/SplitText"
import Arrows from "../../../components/Icons/Arrows"
import { AboutPath } from "../../../routes"
import LogoIcon from "./logo.svg"
import MapImg from "./map.jpg"

const pageVariants = {
  initial: {
    opacity: 0
  },
  in: {
    opacity: 1
  },
  out: {
    opacity: 0
  }
}

const pageTransition = {
  ease: "easeIn",
  duration: 0.7
}

function Future() {
  return (
    <Div100vh>
      <Holder
        initial="initial"
        animate="in"
        exit="out"
        variants={pageVariants}
        transition={pageTransition}
      >
        <Content>
          <LeftSection>
            <TitleHolder>
              <SplitText
                initial="hidden"
                animate="visible"
                variants={{
                  visible: i => ({
                    y: 0,
                    transition: {
                      ease: [0.455, 0.03, 0.515, 0.955],
                      duration: 1.65,
                      delay: i * 0.2
                    }
                  }),
                  hidden: { y: "100%" }
                }}
              >
                Come and
              </SplitText>
              <SplitText
                initial="hidden"
                animate="visible"
                variants={{
                  visible: i => ({
                    y: 0,
                    transition: {
                      ease: [0.455, 0.03, 0.515, 0.955],
                      duration: 1.65,
                      delay: i * 0.2
                    }
                  }),
                  hidden: { y: "100%" }
                }}
              >
                say hi.
              </SplitText>
            </TitleHolder>
            <TipHolder>
              <span>
                Our Sales Suite is open with visits taking place on an
                appointment-only basis. To book a visit and for all futher
                enquiries, please contact us on:
              </span>
            </TipHolder>
            <ContactHolder>
              <ContactList>
                <ContactTitle>Get in Touch:</ContactTitle>
                <ContactValue>
                  <a
                    target="_blank"
                    href="mailto:coronationsquare@taylorwimpey.com"
                    rel="noopener noreferrer"
                  >
                    coronationsquare@taylorwimpey.com
                  </a>
                </ContactValue>
                <ContactValue>+44 (0) 20 8023 6331</ContactValue>
              </ContactList>
              <ContactList>
                <ContactTitle>Sales Suite Address:</ContactTitle>
                <ContactValue>100 Oliver Rd</ContactValue>
                <ContactValue>London</ContactValue>
                <ContactValue>E10 5JY</ContactValue>
              </ContactList>
              <ContactList>
                <ContactTitle>Sales Suite Opening Hours:</ContactTitle>
                <ContactValue>Mon CLOSED</ContactValue>
                <ContactValue>Tue 10:00 - 18:00</ContactValue>
                <ContactValue>Wed 10:00 - 18:00</ContactValue>
                <ContactValue>Thu 10:00 - 18:00</ContactValue>
                <ContactValue>Fri 10:00 - 18:00</ContactValue>
                <ContactValue>Sat 10:00 - 16:00</ContactValue>
                <ContactValue>Sun CLOSED</ContactValue>
              </ContactList>
            </ContactHolder>
          </LeftSection>
          <RightSection img={MapImg}></RightSection>
        </Content>
        <Footer>
          <BackButton to={AboutPath}>
            <IconButton>
              <Arrows flip={1} />
            </IconButton>
          </BackButton>
          <Logo src={LogoIcon} />
        </Footer>
      </Holder>
    </Div100vh>
  )
}

export default Future
